import React, { useEffect, useState } from 'react';
export const Countdown = () => {
  const TOTAL_SECONDS = 20 * 60; // 20 minutos
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const tiles = [{
    label: 'Minutos',
    value: minutes
  }, {
    label: 'Segundos',
    value: seconds
  }];
  return <div className="flex justify-center gap-3 sm:gap-4" data-id="element-1">
      {tiles.map((unit, i) => <div key={i} className="flex flex-col items-center" data-id="element-2">
          <div className="w-20 h-20 sm:w-24 sm:h-24 bg-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center border border-white/20 shadow-soft" data-id="element-3">
            <span className="font-display font-extrabold text-4xl sm:text-5xl text-gold tabular-nums" data-id="element-4">
              {unit.value.toString().padStart(2, '0')}
            </span>
          </div>
          <span className="text-xs sm:text-sm text-white/70 uppercase tracking-wider mt-2 font-medium" data-id="element-5">
            {unit.label}
          </span>
        </div>)}
    </div>;
};